var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('div',{staticClass:"notice-header"},[_c('span',{staticClass:"notice-header-icon"},[_vm._t("notice-header-icon")],2),_c('span',{staticClass:"notice-header-title"},[_vm._t("notice-header-title")],2)]),_c('div',{staticClass:"notice-body"},[_vm._t("notice-body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }